import { ModelProvider } from "../../server/llm/types"
export type ModelInfo = {
  key: string
  label: string
  provider: ModelProvider
  model: string
}

export const models: ModelInfo[] = [
  {
    key: 'gpt-5-mini',
    label: 'GPT-5 Mini',
    provider: 'openai-responses',
    model: 'gpt-5-mini-2025-08-07',
  },
  {
    key: 'gpt-5',
    label: 'GPT-5',
    provider: 'openai-responses',
    model: 'gpt-5-2025-08-07',
  },
  {
    key: 'gpt-5.2',
    label: 'GPT-5.2',
    provider: 'openai-responses',
    model: 'gpt-5.2-2025-12-11',
  },
  {
    key: 'gpt-5.1',
    label: 'GPT-5.1',
    provider: 'openai-responses',
    model: 'gpt-5.1-2025-11-13',
  },
  {
    key: 'gpt-5-codex',
    label: 'GPT-5 Codex',
    provider: 'openai-responses',
    model: 'gpt-5-codex',
  },
  {
    key: 'gpt-5.1-codex',
    label: 'GPT-5.1 Codex',
    provider: 'openai-responses',
    model: 'gpt-5.1-codex',
  },
  {
    key: 'gpt-5.2-codex',
    label: 'GPT-5.2 Codex',
    provider: 'openai-responses',
    model: 'gpt-5.2-codex',
  },
  {
    key: 'haiku',
    label: 'Claude Haiku 4.5',
    provider: 'claude',
    model: 'claude-haiku-4-5-20251001',
  },
  {
    key: 'sonnet',
    label: 'Claude Sonnet 4.5',
    provider: 'claude',
    model: 'claude-sonnet-4-5-20250929',
  },
]

export function getModel( key:string): ModelInfo | undefined {
  return models.find(m=>m.key===key)
}

export function getModelKey(provider: string, model: string): string {
  return `${provider}:${model}`
}

export function parseModelKey(modelKey: string): { provider: string; model: string } | null {
  const parts = modelKey.split(':')
  if (parts.length !== 2) return null
  return { provider: parts[0], model: parts[1] }
}
